import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export const KaliLinuxNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="kalilinux" />;
};
